// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBusinessId, setBusinessInfo, setRoomId, setTableId } from "../../stores/business/businessSlice";
import { PartnerBanner } from "../../components/PartnerBanner";
import { WelcomeBanner } from "../../components/WelcomeBanner";
import { SubBanner } from "../../components/SubBanner";
import { MenuSections } from "../../components/MenuSections";
import { Footer } from "../../components/Footer";
import { useLanguageContext } from "../../context/languageContext";
import { FALLBACK_BUSINESS, FALLBACK_BUSINESS_ID } from "../../data/fallback";
import { API_URL } from "../../config/api";

import TravelActivities from '../../components/TravelActivities';
import CarRentalBanner from '../../components/CarRentalBanner';
import ActivitiesPopup from '../../components/ActivitiesPopup';
import CarRentalFloat from '../../components/CarRentalFloat';

const Home = () => {
    const { t } = useLanguageContext();
    const PUBLIC_TOKEN = "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJkZW5pcy5taW1pbmlAY2xpY2thbGJhbmlhLmNvbSIsImlhdCI6MTc1MDk4MjU3NywiZXhwIjoxNzUxMjQxNzc3fQ.yQ3xGQEfpj62ruJoLJYOl3966g55OlyofRqjoAHzu";
    const location = useLocation();
    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(location.search);
    const businessId = queryParams.get("businessid") || '2';
    const roomId = queryParams.get("roomid");
    const tableId = queryParams.get("tableid");

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (roomId) dispatch(setRoomId(roomId));
        if (tableId) dispatch(setTableId(tableId));
    }, [roomId, tableId, dispatch]);

    useEffect(() => {
        // The API is the source of truth, but a guest who scanned the QR code at the
        // table should never be met with an empty page: whenever it cannot be reached,
        // or the id in the code does not resolve, fall back to the bundled copy of the
        // business and let the menu come from src/data/fallback as well.
        const applyFallback = () => {
            dispatch(setBusinessId(FALLBACK_BUSINESS_ID));
            dispatch(setBusinessInfo(FALLBACK_BUSINESS));
        };

        const validateBusiness = async () => {
            try {
                const response = await fetch(`${API_URL}/api/v1/business/data/${businessId}`, {
                    headers: {
                        Authorization: `Bearer ${PUBLIC_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    dispatch(setBusinessId(businessId));
                    dispatch(setBusinessInfo(data));
                } else {
                    applyFallback();
                }
            } catch (error) {
                applyFallback();
            } finally {
                setLoading(false);
            }
        };

        validateBusiness();
    }, [businessId, dispatch, PUBLIC_TOKEN]);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
                <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="mt-4 text-xs font-bold text-slate-400 uppercase tracking-widest">{t("Loading Experience")}</p>
            </div>
        );
    }

    return (
        <div className="flex-1 bg-slate-50">
            <WelcomeBanner />

            <div className="flex-1">
                {/* The menu first: a guest who just scanned a QR code wants the food,
                    not an introduction to the hotel. */}
                <MenuSections />
                <TravelActivities />
                <CarRentalBanner />
                {/* Everything else reads as a closing note on the way out. */}
                <SubBanner />
                {/* Last: who built it. A guest who liked the menu is the best lead the
                    software side of the business gets. */}
                <PartnerBanner />
            </div>

            <ActivitiesPopup />
            <CarRentalFloat />
            <Footer />
        </div>
    );
};

export default Home;
